(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-products"] && !Shopify.designMode) return;
  try {
    
  const initFeaturedCollectionScrollJack = () => {
    const grids = document.querySelectorAll(
      '[data-testid="featured-collection-products"] .featured-collection-products__products'
    );

    grids.forEach((grid) => {
      if (grid.dataset.scrollJackBound) return;

      const section = grid.closest('[data-testid="featured-collection-products"]');
      if (!section) return;

      grid.dataset.scrollJackBound = 'true';

      let isInView = false;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            isInView = entry.isIntersecting;
          }
        },
        { threshold: 0.2 }
      );
      observer.observe(section);

      const handleWheel = (event) => {
        if (!isInView) return;
        // Cursor already over the grid: let native nested-scroll handle it.
        if (grid.contains(event.target)) return;

        const scrollingDown = event.deltaY > 0;
        const atBottom = grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 1;
        const atTop = grid.scrollTop <= 0;

        if ((scrollingDown && !atBottom) || (!scrollingDown && !atTop)) {
          event.preventDefault();
          grid.scrollTop += event.deltaY;
        }
      };

      window.addEventListener('wheel', handleWheel, { passive: false });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionScrollJack);
  } else {
    initFeaturedCollectionScrollJack();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
